import { useState } from 'react'

export const usePreDocument = () => {
  const [modal, setModal] = useState('')

  return [modal, setModal]
}
